// Цвета чипов токенов формулы — единое место для редактирования.
export const PARAM_TYPE_COLORS = {
  source: {
    bg: "#ffffff",
    text: "#1d4ed8",
    badge: "#1d4ed8",
  },
  value: {
    bg: "#dbeafe",
    text: "#1d4ed8",
    badge: "#3b82f6",
  },
  calculated: {
    bg: "#dcfce7",
    text: "#15803d",
    badge: "#15803d",
  },
};
